<template>
  <!-- <div id="app">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view class="keepAlive" />
    </keep-alive>
    <router-view class="keepAliveNo" v-if="!$route.meta.keepAlive" />
  </div> -->
  <div id="app">
    <router-view class="keepAlive" />
  </div>
</template>

<script>
// import Cookies from 'js-cookie'

export default {
  components: {
    // routeTransition
  },
  data() {
    return {
      transitionName: '',
    }
  },
  // watch: {
  //   '$route' (to, from) {
  //     // const toDepth = to.path.split('/').length
  //     // const fromDepth = from.path.split('/').length\
  //     // this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
  //     console.log(to)
  //     console.log(from)
  //     let isBack = Cookies.get('isBack')
  //     Cookies.remove('isBack')
  //     console.log(isBack)
  //     if (isBack) {
  //       this.transitionName = 'slide-to-right'
  //     } else {
  //       this.transitionName = 'slide-to-left'
  //     }
  //     // let prevPageName = Cookies.get('prevPageName')
  //     // Cookies.set('prevPageName', from.name)
  //     // console.log(prevPageName)
  //   }
  // },
  mounted() {
    let vh = window.innerHeight;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight;
      console.log(vh);
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
  created() {
  }
};
</script>

<style>
#app {
  height: 100vh;
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}
@font-face {
  font-family: 'iconfont';  /* project id 1820373 */
  src: url('//at.alicdn.com/t/font_1820373_11ldr5ykulq.eot');
  src: url('//at.alicdn.com/t/font_1820373_11ldr5ykulq.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1820373_11ldr5ykulq.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1820373_11ldr5ykulq.woff') format('woff'),
  url('//at.alicdn.com/t/font_1820373_11ldr5ykulq.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1820373_11ldr5ykulq.svg#iconfont') format('svg');
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

/* .slide-to-right-enter-active, .slide-to-right-leave-active {
  transition: all .3s;
}
.slide-to-right-enter, .slide-to-right-leave-to{
  opacity: 0;
  transform: translateX(100%);
}
.slide-to-left-enter-active, .slide-to-left-leave-active {
  transition: all .3s;
}
.slide-to-left-enter{
  transform: translateX(100%);
}
.slide-to-left-leave-to{
  opacity: 0;
  transform: translateX(0%);
} */
</style>
